var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.parts),function(part,index){return _c(part.match ? 'mark' : 'span',{key:(index + "-" + (part.text)),tag:"component",class:{'workforce-search-highlight': part.match}},[_vm._v(" "+_vm._s(part.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }